import { Link as GatsbyLink, GatsbyLinkProps } from 'gatsby';
import React from 'react';

const { APP_ROOT } = require('utils/constants/urls');

export interface ILInk {
  to: string;
  children?: GatsbyLinkProps<Record<string, unknown>>['to'];
  className?: string;
  activeClassName?: string;
  partiallyActive?: boolean;
  tabIndex?: number;
}

const Link: React.FC<ILInk> = (props) => {
  const {
    children,
    to,
    className,
    activeClassName,
    partiallyActive,
    tabIndex,
  } = props;

  // internal link is that will start with exactly one slash or include app_root once app_root is not null
  const internal = /^\/(?!\/)/.test(to) || (APP_ROOT && to.includes(APP_ROOT));

  // Use Gatsby Link for internal links, and <a> for external links
  if (internal) {
    const gatsbyProps: any = { to, className, tabIndex };
    // Only pass these props if not in test environment to avoid warnings with jest mocks
    if (process.env.NODE_ENV !== 'test') {
      if (activeClassName) {
        gatsbyProps.activeClassName = activeClassName;
      }
      if (typeof partiallyActive !== 'undefined') {
        gatsbyProps.partiallyActive = partiallyActive;
      }
    }

    return <GatsbyLink {...gatsbyProps}>{children}</GatsbyLink>;
  }

  // For external links, don't pass the Gatsby-specific props
  return (
    <a href={to} className={className} tabIndex={tabIndex}>
      {children}
    </a>
  );
};

export default Link;
